/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
export function useTimeout() {
  const timeoutRef = React.useRef(null);
  const clear = React.useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);
  const set = React.useCallback(function (callback, ms) {
    clear();
    for (var _len = arguments.length, arg = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      arg[_key - 2] = arguments[_key];
    }
    timeoutRef.current = setTimeout(callback, ms, ...arg);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    return clear;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return {
    clear,
    set
  };
}